var MAX_SLIDE_VIEW = 3.1;
var MIN_SLIDE_VIEW = 1.2;
var MIDDLE_SLIDE_VIEW = 2.1;
var ENABLED_CAROUSEL = 4;

/**
 * Поинты для корретного отображения новых карточек в "Carousel"
 */
var BIG_DESKTOP_WIDTH = 1260;
var SMALL_DESKTOP_WIDTH = 768;
export { BIG_DESKTOP_WIDTH, ENABLED_CAROUSEL, MAX_SLIDE_VIEW, MIDDLE_SLIDE_VIEW, MIN_SLIDE_VIEW, SMALL_DESKTOP_WIDTH };